import type { College } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

const EXCLUDED_KEYS = new Set([
  'academic_profile_id',
  'ipeds_id',
  'latitude',
  'longitude',
  'created_at',
  'updated_at',
  'logo_media_id',
  'logo_media_url',
  'banner_media_id',
  'banner_media_url',
]);

export const useAgentContext = (college?: College) => {
  useRegisterAgentContext(
    college
      ? {
          kind: 'entity',
          description: 'The college the user is viewing',
          data: Object.fromEntries(Object.entries(college).filter(([k]) => !EXCLUDED_KEYS.has(k))),
        }
      : null,
  );
};
